import { colors } from '@material-ui/core'

const MuiTableCell = {
  head: {
    color: '#263238',
    fontWeight: 700,
    borderColor: colors.grey[300],
  },
  root: {
    borderBottom: `1px solid ${colors.grey[300]}`,
  },
}

export default MuiTableCell
